module.exports = __webpack_public_path__ + "img/bank_07.0ab88ca7.png";